import { render, staticRenderFns } from "./OrmBatchingListView.vue?vue&type=template&id=5576a2e8"
import script from "./OrmBatchingListView.vue?vue&type=script&lang=js"
export * from "./OrmBatchingListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports